import { Action } from '@ngrx/store';
import { ClientRole } from '@model';

export enum CustomerRolesActionTypes {
  CustomerRolesLoadData = '[CustomerRoles] Load data',
  CustomerRolesSuccess = '[CustomerRoles] Load success',
  CustomerRolesFail = '[CustomerRoles] Load fail'
}

export class CustomerRolesLoadData implements Action {
  readonly type = CustomerRolesActionTypes.CustomerRolesLoadData;
  constructor(public payload: string) {}
}

export class CustomerRolesLoadSuccess implements Action {
  readonly type = CustomerRolesActionTypes.CustomerRolesSuccess;
  constructor(public payload: ClientRole[]) {}
}

export class CustomerRolesLoadFail implements Action {
  readonly type = CustomerRolesActionTypes.CustomerRolesFail;
  constructor(public payload: any) {}
}

export type CustomerRolesActions = CustomerRolesLoadData | CustomerRolesLoadSuccess | CustomerRolesLoadFail;
